// JS exports mirroring Colors.scss — import these when you need color values in JavaScript.
// Keep in sync with Colors.scss when palette values change.

export const textColor = '#292727';
export const darkTextColor = '#696969';
export const lightTextColor = '#cacacb';
export const black = 'black';
export const borderColor = '#c0c0c0';
export const gridBorderColor = '#ddd';
export const hoverColor = '#b8b8b8';
export const shadow = '#9c9c9c';
export const gray = '#efefef';
export const darkGray = '#515554';
export const backgroundColor = '#ffffff';
export const backgroundRight = '#ffffff';
export const backgroundLeft = '#e9e9e9';
export const success = '#18b100';
export const headingsGray = '#333333';
export const camelGold = '#d0ad4d';
export const gold = '#dabc64';
export const iconColor = '#9c9c9c';
export const navIcon = '#4d4d4d';
export const navIconActive = '#dabc64';
export const iconColorActive = '#dabc64';
export const magenta = '#ab3a72';
export const habitPrimary = 'rgb(51, 51, 51)';
export const habitBorder = 'rgb(208, 213, 221)';
export const habitActionText = 'rgb(86, 86, 86)';
export const habitActionIcon = '#565656';

// Brands
export const brandPrimary = '#3097d1';
export const brandInfo = '#8eb4cb';
export const brandSuccess = '#2ab27b';
export const brandWarning = '#cbb956';
export const brandDanger = 'red';

export const orange = '#f5a000';

export const inputColor = '#555';
export const headingColor = '#999';
export const dayHeadingColor = '#555';
export const undoBackground = '#bdbdbd';
